(function () {
  "use strict";

  class CareerMessageBgChange {
    constructor(wrap) {
      this.wrap = wrap;
      this.target = wrap.querySelector('.l-wrapper');
      this.trigger = wrap.querySelector('.js-bg-change-trigger');
      this.changeClass = "is-change-bg";
      this.offset = 300;

      this._onScroll = this._onScroll.bind(this);

      this.init();
    }

    init() {
      if (!this.target || !this.trigger) return;
      window.addEventListener('scroll', this._onScroll);
      this._onScroll(); // 初回実行
    }

    _onScroll() {
      const triggerRect = this.trigger.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;

      const lowerThreshold = windowHeight - this.offset;
      const upperThreshold = 0 + this.offset;

      if (triggerRect.top < lowerThreshold && triggerRect.bottom > upperThreshold) {
        this.target.classList.add(this.changeClass);
      } else {
        this.target.classList.remove(this.changeClass);
      }
    }
  }

  const careerMessage = document.querySelector(".page-careerMessage");

  if (careerMessage) {
    new CareerMessageBgChange(careerMessage);
  }
})();
